import { StatusBadge, Tooltip } from '@movingimage-evp/mi-ui-component-library';
import { useTranslation } from 'react-i18next';

import styles from './restricted-badge.module.css';

export function RestrictedBadge() {
  const { t } = useTranslation();

  return (
    <Tooltip label={t('manager.components.restrictedBadge.tooltip')}>
      <StatusBadge data-testid="restricted-badge" status="warning" className={styles.badge}>
        {t('manager.components.restrictedBadge.label')}
      </StatusBadge>
    </Tooltip>
  );
}
